import CommentFormController from './comment-form-controller'

export default class extends CommentFormController {
  connect () {
    this.commentBranch = this.element.closest('.comment-branch')
    this.commentContainer = this.element.closest('.comment')
    this.commentBody = this.commentContainer.querySelector('.comment__body')

    this._focusTextField()
  }

  handleCancelButtonClick () {
    this._cancelEdit()
  }

  // -----------------------------------------------------------------------------------------------

  _handleFormSuccessResponse (response) {
    this.commentBody.remove()
    this._hideVote()
    this._hideAlert()
    this._hideNotice()
    this._hideReply()
    this._appendComment(response)
    this._hideForm()
  }

  _appendComment (response) {
    this.commentContainer.insertAdjacentHTML('beforeend', response)
  }

  _cancelEdit () {
    this.commentBody.classList.remove('d-none')
    this._hideForm()
  }

  _hideVote () {
    try {
      this.commentContainer.querySelector('.votes').remove()
    } catch (e) {}
  }

  _hideReply () {
    try {
      this.commentBranch.querySelector('.comment-reply').remove()
    } catch (e) {}
  }

  _hideAlert () {
    try {
      this.commentContainer.querySelector('.alert').remove()
    } catch (e) {}
  }

  _hideNotice () {
    try {
      this.commentContainer.querySelector('.notice').remove()
    } catch (e) {}
  }

  _hideForm () {
    this.element.closest('.comments-form').remove()
  }

  // Focus and move cursor to end.
  _focusTextField () {
    const val = this.textFieldTarget.value
    this.textFieldTarget.focus()
    this.textFieldTarget.value = ''
    this.textFieldTarget.value = val
  }
}
